<template>
  <v-app>
    <Nav></Nav>
    <v-content>
      <router-view />
      <Footer></Footer>
    </v-content>
  </v-app>
</template>

<script>
import Nav from "./components/nav";
import Footer from "./components/footer";
export default {
  name: "App",
  components: {
    Nav,
    Footer,
  },
  data: () => ({}),
};
</script>

<style lang="scss">
@font-face {
  font-family: George;
  src: url(/v2/fonts/George.otf);
  font-weight: 400;
}
@font-face {
  font-family: George;
  src: url(/v2/fonts/George-Bold.otf);
  font-weight: 700;
}
@font-face {
  font-family: George;
  src: url(/v2/fonts/George-Light.otf);
  font-weight: 300;
}
@font-face {
  font-family: George;
  src: url(/v2/fonts/George-Semibold.otf);
  font-weight: 600;
}
#app {
  background-color: #ffffff !important;
}
html {
  font-size: 0.8rem !important;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "George", sans-serif !important;
  font-weight: 400;
  letter-spacing: 4px;
  text-transform: uppercase;
}
h1,
h2 {
  color: #000000;
}
h3,
h4,
h5,
h6 {
  color: #707070;
}
h1 {
  font-size: 2rem;
  margin-bottom: 0.7rem;
}
h2 {
  font-size: 1.7rem;
  margin-bottom: 0.7rem;
}
h3 {
  font-size: 1.4rem;
  margin-bottom: 0.7rem;
}
h4 {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
h5 {
  font-size: 1rem;
  margin-bottom: 0.2rem;
}
h6 {
  font-size: 0.8rem;
}
a {
  text-decoration: none;
}

a.contact {
  display: block;
  margin: 0.5rem 0;
  text-decoration: none;
  i {
    color: #bebebd !important;
  }
}
</style>
